import React from 'react'
import { LoadingButtonProps } from '@mui/lab'
import { MarginSpacing } from 'commons/styles/spacing'
import { StyledButton, ButtonSizes } from './styles'

type Props = {
  id?: string
  uppercased?: boolean
  margin?: MarginSpacing
  size?: ButtonSizes
  padding?: MarginSpacing
} & Omit<LoadingButtonProps, 'size'>

const Button = ({ id, uppercased = false, variant = 'outlined', margin, size = 'unset', padding, ...props }: Props) => {
  return (
    <StyledButton
      id={id}
      data-testid={id}
      $uppercased={uppercased}
      variant={variant}
      $size={size}
      $margin={margin}
      $padding={padding}
      {...props}
    />
  )
}

export default Button
